import React from 'react';

import { useIntl } from 'react-intl-next';

import SearchIcon from '@atlaskit/icon/core/search';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { highlightMatchedText } from '@atlassian/dynamic-cards-search-common';

import { SearchLink } from '../../../../../common/ui/search-link';
import { useDropdown, useInputQuery } from '../../../../../controllers/store';
import {
	useAutoSuggestionResults,
	useRecentSearchResults,
	useResultCount,
} from '../../../../../controllers/store/dropdown';

import { messages } from './messages';

const iconStyles = xcss({
	backgroundColor: 'color.background.neutral',
	borderRadius: 'border.radius.050',
	width: '24px',
	height: '24px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});

export const AutoSuggestion = () => {
	const [inputQuery, { setSearchQuery }] = useInputQuery();
	const [, { setShowDropdown }] = useDropdown();
	const intl = useIntl();

	const [recentSearchResults] = useRecentSearchResults();
	const [autoSuggestionResults] = useAutoSuggestionResults();
	const [resultCount] = useResultCount();

	const recentSearchTitles = recentSearchResults
		.slice(0, resultCount.recentSearch)
		.map((search) => search.title.toLowerCase());
	const filteredAutoSuggestions = autoSuggestionResults.results
		.filter((suggestion) => {
			return (
				!recentSearchTitles.includes(suggestion.title.toLowerCase()) &&
				suggestion.title !== inputQuery.toLowerCase()
			);
		})
		.slice(0, resultCount.autoSuggestion);

	return (
		<>
			{filteredAutoSuggestions.map((suggestion, index) => (
				<SearchLink
					title={suggestion.title || ''}
					icon={
						<Box xcss={iconStyles}>
							<SearchIcon
								color="currentColor"
								label={intl.formatMessage(messages.searchIconLabel)}
							/>
						</Box>
					}
					onClick={() => {
						setSearchQuery(suggestion.title || '');
						setShowDropdown(false);
					}}
					highlightedTitle={
						highlightMatchedText(suggestion.title, inputQuery.split(' ')).negatedHighlightedTitle
					}
					key={`${index}-${suggestion.title}`}
				/>
			))}
		</>
	);
};
